module.exports = __webpack_public_path__ + "static/media/right-arrow.0a21d44e.svg";